import { createFileRoute } from '@tanstack/react-router';
import { UserListPage } from '@/pages/admin/users/UserListPage';

export const Route = createFileRoute('/admin/users/')({
  component: UserListPage
});
